<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{params.action}}</div>
    <div slot="body">
      <a-form-model
        v-bind="formItemLayout"
        ref="form"
        class="mt-3"
        :model="form"
        :rules="rules">
        <a-form-model-item :label="$t('table.title.name')" prop="name">
          <a-input v-model="form.name" :placeholder="$t('common.tips.input', [$t('table.title.name')])" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'

export default {
  name: 'AnalysisSaveReportDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        name: '',
      },
      rules: {
        name: [
          {
            required: true,
            max: 256,
            message: this.$t('validator.maxLength', ['256']),
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
    }
  },
  created () {
    this.$aM = new this.$Manager('bill_analysis_reports', 'v1')
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        const data = R.clone(this.params.formData)
        if (data.hasOwnProperty('cloudprovider')) {
          data.cloudprovider_id = data.cloudprovider
          delete data.cloudprovider
        }
        const res = await this.$aM.create({
          data: {
            name: this.form.name,
            queryAttributes: {
              formData: data,
            },
          },
        })
        this.loading = false
        this.cancelDialog()
        this.params.refresh(res.data)
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
